import { NAVIGATION_HISTORY_PUSH } from 'services/navigation/actions'
import { URL_AMBASSADORS, URL_HOME } from 'services/url/constants'
import { SET_APP_BOOTSTRAP_PHASE } from 'services/app/actions'
import { SET_AUTH_LOGIN_SUCCESS } from 'services/auth/actions'
import { SET_RESOLVER_DATA } from 'services/resolver/actions'
import { ROLE_ID_AMBASSADOR } from 'services/auth-access'
import { getAuthIsLoggedIn } from 'services/auth'

import { AMBASSADORS_GET_PAYOUT, AMBASSADORS_SET_PAYOUT, AMBASSADORS_SET_PAYOUT_PROCESSING } from './actions'
import { getAmbassadorPayout } from '.'


function isAmbassadorsPage ({ state }) {
  const { resolver } = state
  return resolver.getIn(['data', 'path']) === URL_AMBASSADORS
}

/**
 * Watcher for Ambassadors page "/ambassadors"
 * when the page is mounted.
 */
// eslint-disable-next-line import/prefer-default-export
export function watchAmbassadorsPageMount ({ after }) {
  return after([
    SET_APP_BOOTSTRAP_PHASE,
    SET_AUTH_LOGIN_SUCCESS,
    SET_RESOLVER_DATA,
  ],
  async ({ dispatch, state }) => {
    const { auth } = state

    if (getAuthIsLoggedIn(auth) && auth.get('roleIds').includes(ROLE_ID_AMBASSADOR)) {
      dispatch({
        type: AMBASSADORS_SET_PAYOUT_PROCESSING,
        payload: { processing: true },
      })
      const data = await getAmbassadorPayout({ auth })
      dispatch({
        type: AMBASSADORS_SET_PAYOUT,
        payload: { data },
      })
    } else {
      dispatch({
        type: NAVIGATION_HISTORY_PUSH,
        payload: { url: URL_HOME },
      })
    }
  })
    .when(isAmbassadorsPage)
}

/**
 * Watcher for getting payouts data
 */
export function getAmbassadorPayouts ({ after }) {
  return after([
    AMBASSADORS_GET_PAYOUT,
  ], async ({ dispatch, state, action }) => {
    const { auth } = state
    const { payload: year } = action
    dispatch({
      type: AMBASSADORS_SET_PAYOUT_PROCESSING,
      payload: { processing: true },
    })
    const data = await getAmbassadorPayout({ auth, year })
    dispatch({
      type: AMBASSADORS_SET_PAYOUT,
      payload: { data },
    })
  })
}
